import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import Error from "./Error";
import { BsTrash3, BsTrash3Fill } from "react-icons/bs";
import HoverButton from "../components/HoverButton";
import { GrStatusGoodSmall } from "react-icons/gr";
import { MdForest } from "react-icons/md";
import { RiFileEditFill, RiFileEditLine } from "react-icons/ri";
import Modal from "../components/Modal";
import { BsPlusSquare, BsPlusSquareFill } from "react-icons/bs";
import { getObjectValue } from "../utils/utils";
import { useNavigate } from "react-router-dom";
import Loading from "./Loading";
import Site from "../classes/Site";

function SiteSelection({ currentProfile, isMobile, setCurrentProfile, sitesFetched }) {
    const [locationDisplayKeys, setLocationDisplayKeys] = useState(["status", "name", "access"]);
    const [locationForms, setLocationForms] = useState(["Name (Cannot be Changed)", "Owner", "Status"]);
    const [locationFormNames, setLocationFormNames] = useState(["name", "owner", "status"]);
    const [headers, setHeaders] = useState([{ "name": "Status", "display": true }, { "name": "Site Name", "display": true }, { }, { }]);
    const [allLocations, setAllLocations] = useState(null);
    const [updatedLocations, setUpdatedLocations] = useState(null);
    const [updateLocation, setUpdateLocation] = useState(null);
    const [updateLocationObject, setUpdateLocationObject] = useState(null);
    const [addNewSite, setAddNewSite] = useState(false);
    const [removeLocation, setRemoveLocation] = useState(null);
    const [updatedLocation, setUpdatedLocation] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [modalError, setModalError] = useState("");

    let navigate = useNavigate();

    useEffect(() => {
        document.title = 'Sites';
    });

    const handleChange = (e) => {
        setModalError("");
        e.preventDefault();
        setUpdatedLocation(true);

        let siteToEdit = { ...updateLocationObject };
        Object.assign(siteToEdit, { [e.target.name]: e.target.value });
        // console.log({ [e.target.name]: e.target.value });

        setUpdateLocationObject(siteToEdit);
    };

    const saveLocation = async () => {
        let siteToSave = new Site(updateLocationObject.name, updateLocationObject.access, updateLocationObject.status, updateLocationObject.owner);
        // console.log(siteToSave);

        if(!siteToSave.name || !siteToSave.owner) {
            setModalError("Cannot save site, missing field(s)");
            return;
        }

        if(siteToSave.name.toLowerCase().includes("-wildlifeinvestments") || siteToSave.name.toLowerCase().includes(" wildlifeinvestments")) {
            setModalError("Cannot save site, invalid name.");
            return;
        }

        let wasSuccessful = await siteToSave.saveResource(currentProfile.accessToken, addNewSite);
        if(wasSuccessful) {
            updatedLocations[updateLocation] = siteToSave;
            setAllLocations(updatedLocations);
            setUpdatedLocation(false);
            setAddNewSite(false);
            setUpdateLocation(null);
            setUpdateLocationObject(null);
            setCurrentProfile({ ...currentProfile, "sites": updatedLocations });
        } else {
            setModalError("Failed to save Site, please refresh the page and try again.");
        }
    };

    const deleteLocation = () => {
        let allLocationsClone = [...allLocations];
        let siteToDelete = allLocations[removeLocation];

        let wasSuccessful = siteToDelete.deleteResource(currentProfile.accessToken);
        if(!wasSuccessful) {
            setModalError("Failed to delete Site, please refresh the page and try again.");
        }

        allLocationsClone.splice(removeLocation, removeLocation + 1);
        
        setCurrentProfile({ ...currentProfile, "sites": allLocationsClone });

        if(Object.keys(allLocationsClone).length === 0) {
            allLocationsClone = null;
        }

        setAllLocations(allLocationsClone);
        setRemoveLocation(null);
    };

    const addLocation = () => {
        setUpdateLocation(updatedLocations.length);
        setAddNewSite(true);
        let defaultLocationObject = new Site("", "", "active", "");
        setUpdateLocationObject(defaultLocationObject);
    };

    useEffect(() => {
        if(currentProfile && getObjectValue(currentProfile, "sites")) {

            if(!currentProfile.isAdmin) {
                setLocationDisplayKeys(["name", "access"]);
                setLocationForms(["Name (Cannot be Changed)", "Owner"]);
                setLocationFormNames(["name", "owner", "status"]);
                setHeaders([{ "name": "Site Name", "display": true }]);
            }
            setAllLocations(currentProfile.sites);
            setUpdatedLocations(currentProfile.sites);
        }
    }, [currentProfile]);

    const viewLocationData = (location) => {
        let siteIndex = location ? location : selectedLocation;
        let site = allLocations[siteIndex];
        if(site && site.slug) {
            navigate(`/sites/${site.slug}/inventory`);
        }
    };

    if (currentProfile && currentProfile.sites) {
        const width = isMobile ? `${(100 / headers.length) - 2}%` : `${100 / (headers.length + 2)}%`;
        return (
            <>
                <div style={{ "minHeight":"86vh" }} className="w3-content w3-container w3-padding-64" id="about">
                    <div style={{ "display": "flex", "alignItems": "center" }}>
                        <div style={{ "display": "flex", "alignItems": "center", "width": "100%" }}>
                            <MdForest style={{ "transform": "scale(2.0)", "marginRight": "12px" }} />
                            <h3>Sites</h3>
                        </div>
                    </div>
                    {currentProfile.isAdmin ? (
                        null
                    ) : currentProfile.sites && currentProfile.sites.length === 0 ? (
                        <p>You have not yet been added to a site, please reach out to a member of the Wildlife Investments Team or your Hunting Club Administrator to be added.</p>
                    ) : null}
                    {updateLocation || addNewSite ? (
                        <Modal style={isMobile ? {} : { "width": "450px" }} closeButton={true} fadeIn={0.25} isMobile={isMobile} onClose={() => { setUpdateLocation(null); setAddNewSite(false); setModalError(""); }}>
                            {addNewSite ? (
                                <h4>Add Site</h4>
                            ) : (
                                <h4>Edit Site</h4>
                            )}
                            {locationForms.map((locationForm, index) => {
                                let locationToEdit = updateLocationObject;
                                let name = locationFormNames[index];
                                let value = locationToEdit[name];
                                if(name === "status") {
                                    return(
                                        <div key={locationForm} style={{ "display": "flex", "marginTop": "16px" }}>
                                            <input
                                                key={JSON.stringify(locationToEdit) + name + (value === "active") + index}
                                                style={{ "marginRight":"6px" }}
                                                type="radio"
                                                checked={value === "active"}
                                                name={name}
                                                value={"active"}
                                                onChange={(e) => { handleChange(e); }}
                                            />
                                            <label style={{ "marginRight": "16px" }}>
                                                Active
                                            </label>
                                            <input
                                                key={JSON.stringify(locationToEdit) + name + (value === "inactive") + index}
                                                style={{ "marginRight":"6px" }}
                                                type="radio"
                                                checked={value === "inactive"}
                                                name={name}
                                                value={"inactive"}
                                                onChange={(e) => { handleChange(e); }}
                                            />
                                            <label>
                                                Inactive
                                            </label>
                                        </div>
                                    );
                                } else if (name === "name" && value && !addNewSite) {
                                    return(
                                        <React.Fragment key={locationForm}>
                                            <p><b>{locationForm}</b></p>
                                            <p style={{ "width": "100%", "padding": "6px", "border": "2px solid #e8eaf6" }}>
                                            {value}
                                            </p>
                                        </React.Fragment>
                                    );
                                } else {
                                    return(
                                        <React.Fragment key={locationForm}>
                                            <p><b>{locationForm}</b></p>
                                            <input
                                                style={{ "width": "100%", "padding": "6px", "border": "2px solid #e8eaf6" }}
                                                name={name}
                                                value={value}
                                                onChange={(e) => handleChange(e)}
                                            />
                                        </React.Fragment>
                                    );
                                }
                            })}
                            <button style={{ "marginTop": "16px", "width": "100%" }} className="main-button" onClick={() => saveLocation()} disabled={!updatedLocation}>
                                Save Site
                            </button>
                            <div className="form-error" style={{ "marginBottom":"8px" }}>{modalError}</div>
                        </Modal>
                    ) : removeLocation ? (
                        <Modal style={isMobile ? {} : { "width": "450px" }} closeButton={true} fadeIn={0.25} isMobile={isMobile} onClose={() => { setRemoveLocation(null); setModalError(""); }}>
                            <h4><b>Delete Site</b></h4>
                            <p>Are you sure you want to delete this site, it will no longer be visible to anyone and will be permanently deleted?</p>
                            <button style={{ "marginTop": "16px", "width": "100%" }} className="main-button" onClick={() => deleteLocation()}>
                                Delete Site
                            </button>
                            <div className="form-error" style={{ "marginBottom":"8px" }}>{modalError}</div>
                        </Modal>
                    ) : null}
                    {allLocations && Object.keys(allLocations).length > 0 ? (
                        <React.Fragment>
                            <div style={{ "width": "100%", "display": "flex"}}>
                                {headers.map((header) => {
                                    if(header.display) {
                                        return(
                                            <div key={header.name} style={{ "width": width, "marginLeft": "32px" }}>
                                                <p>{header.name}</p>
                                            </div>
                                        );
                                    } else {
                                        return(null);
                                    }
                                })}
                            </div>
                            {Object.keys(allLocations).map((latlonKey) => {
                                let divStyle = { "paddingTop": "32px", "paddingBottom": "32px", "marginBottom": "16px", "border": "2px solid white", "borderRadius": "8px", "height": "113px", "display": "flex", "alignItems": "center" };
                                let location = allLocations[latlonKey];
                                if(latlonKey === selectedLocation) {
                                    divStyle = { ...divStyle, "border": "2px solid black" };
                                }
                                return(
                                    <div 
                                        onClick={() => { 
                                            if(selectedLocation === latlonKey) {
                                                setSelectedLocation(null);
                                            } else {
                                                setSelectedLocation(latlonKey);
                                            }
                                        }}
                                        onDoubleClick={() => {
                                            viewLocationData(latlonKey);
                                        }}
                                        key={JSON.stringify(location)} 
                                        style={divStyle} 
                                        className="w3-card" 
                                    >
                                        <div style={{ "display": "flex", "width": "100%", "alignItems": "center" }}>
                                            {isMobile && selectedLocation === latlonKey ? (
                                                <div style={{ "width": width, "marginLeft": "32px" }}>
                                                    <div style={{ "display": "flex" }}>
                                                        {location.status === 'active' ? (
                                                            <GrStatusGoodSmall style={{ "color": "green", "marginTop": "4px", "marginRight": "4px" }} />
                                                        ) : (
                                                            <GrStatusGoodSmall style={{ "color": "red", "marginTop": "4px", "marginRight": "4px" }} />
                                                        )}
                                                        <p style={{ "margin": "0px", "textTransform": "capitalize" }}>
                                                            {location.status}
                                                        </p>
                                                    </div>
                                                </div>
                                            ) : (
                                                <React.Fragment>
                                                    {locationDisplayKeys.map((locationDisplayKey) => {
                                                        return(
                                                            <div key={locationDisplayKey} style={{ "width": width, "marginLeft": "32px" }}>
                                                                {typeof locationDisplayKey === "object" ? (
                                                                    <React.Fragment>
                                                                        {locationDisplayKey.map((key) => {
                                                                            return(
                                                                                <p key={key} style={{ "margin": "0px" }}>
                                                                                    {location[key]}
                                                                                </p>
                                                                            );
                                                                        })}
                                                                    </React.Fragment>
                                                                ) : locationDisplayKey === "access" ? (
                                                                    <React.Fragment>
                                                                        {location[locationDisplayKey] === "owner" ? (
                                                                            <p style={{ "margin": "0px", "textTransform": "capitalize", "color": "gray" }}>
                                                                                Site Owner
                                                                            </p>
                                                                        ) : null}

                                                                    </React.Fragment>
                                                                ) : locationDisplayKey === "status" ? (
                                                                    <div style={{ "display": "flex" }}>
                                                                        {location[locationDisplayKey] === 'active' ? (
                                                                            <GrStatusGoodSmall style={{ "color": "green", "marginTop": "4px", "marginRight": "4px" }} />
                                                                        ) : (
                                                                            <GrStatusGoodSmall style={{ "color": "red", "marginTop": "4px", "marginRight": "4px" }} />
                                                                        )}
                                                                        <p style={{ "margin": "0px", "textTransform": "capitalize" }}>
                                                                            {location[locationDisplayKey]}
                                                                        </p>
                                                                    </div>
                                                                ) : (
                                                                    <p style={{ "margin": "0px", "textTransform": "capitalize" }}>
                                                                        {location[locationDisplayKey]}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </React.Fragment>
                                            )}
                                            {(location.access === "owner" || currentProfile.isAdmin) && (!isMobile || (isMobile && selectedLocation === latlonKey)) ? (
                                                <React.Fragment>
                                                    <div style={{ "width": width, "display": "flex", "justifyContent": "center" }}>
                                                        <HoverButton
                                                            normalIcon={<RiFileEditLine style={{ "transform": "scale(2.0)"}} />} 
                                                            hoverIcon={<RiFileEditFill style={{ "transform": "scale(2.0)"}} />}
                                                            updateParent={() => { setUpdateLocationObject(updatedLocations[latlonKey]); setUpdateLocation(latlonKey); }}
                                                            title={"Edit Location"}
                                                        />
                                                    </div>
                                                    <div style={{ "width": width, "display": "flex", "justifyContent": "center" }}>
                                                        <HoverButton
                                                            normalIcon={<BsTrash3 style={{ "transform": "scale(2.0)"}} />} 
                                                            hoverIcon={<BsTrash3Fill style={{ "transform": "scale(2.0)"}} />}
                                                            updateParent={() => { setRemoveLocation(latlonKey); }}
                                                            title={"Delete Location"}
                                                        />
                                                    </div>
                                                </React.Fragment>
                                            ) : null}
                                        </div>
                                    </div>
                                )
                            })}
                        </React.Fragment>
                    ) : null}
                </div>
                <div className="navbar-bottom">
                    <div className="w3-bar w3-wide w3-padding w3-card w3-white" style={{ "display": "flex", "justifyContent": "center" }}>
                        <div style={isMobile ? { "width": "100%", "display": "flex", "justifyContent": "right" } : { "width": "75%", "display": "flex", "justifyContent": "right", "alignItems": "center" }}>
                            <button className="main-button" onClick={() => { viewLocationData(); }} disabled={!selectedLocation}>
                                View Site
                            </button>
                            {currentProfile.isAdmin ? (
                                <HoverButton 
                                    normalIcon={<BsPlusSquare style={{ "transform": "scale(2.5)"}} />}
                                    hoverIcon={<BsPlusSquareFill style={{ "transform": "scale(2.5)"}} />}
                                    updateParent={() => { addLocation(); }}
                                    style={{ "marginLeft": "32px" }}
                                    title={"Add New Site"}
                                />
                            ) : (
                                null
                            )}
                        </div>
                    </div>
                </div>
            </>
        );
    } else if(!currentProfile && typeof currentProfile === "boolean") {
        return(
            <Error isMobile={isMobile} type={"login"} />
        );
    } else if(sitesFetched) {
        return(
            <Error isMobile={isMobile} text={"failed to get sites"} />
        );
    } else {
        return(
            <Loading isMobile={isMobile} text={"your sites"}/>
        );
    }
}

SiteSelection.propTypes = {
    isMobile: PropTypes.bool,
    isPage: PropTypes.bool,
    currentProfile: PropTypes.object,
    setCurrentProfile: PropTypes.func.isRequired
};

export default SiteSelection;
